import { RegistrationData } from './registrationForm.types';

export const DefaultRegistrationData: RegistrationData = {
  email: '',
  password: '',
  firstName: '',
  middleName: '',
  lastName: '',
  gender: '',
  address: {
    suggestionSelected: false,
    autocompleteAddress: '',
    addressContainer: undefined,
    useAutoAddress: true,
    unit: '',
    streetName: '',
    buildingNumber: '',
    city: '',
    postalCode: '',
    province: '',
    provinceCode: '',
    country: 'Canada',
    countryCode: 'CA',
  },
  occupation: '',
  industry: '',
  phone: {
    phoneNumber: '',
    phoneCode: '+1',
    phoneCountry: 'CA',
  },
  birthDate: '',
  terms: false,
  fit: false,
  age: false,
  pep: false,
  marketing: true,
  marketingMeta: {},
  marketingMetaHistory: [],
  limits: {
    Loss: {},
  },
  firstStep: false,
};

export const industriesWithoutOccupation = [
  'Homemaker',
  'Retired',
  'Student',
  'Unemployed',
];

export const defaultDateFormat = 'MM/DD/YYYY';
export const ymdDateFormat = 'YYYY-MM-DD';
